import { useUserRole } from './useUserRole';
import { useCallback } from 'react';

export function useLoginRedirect() {
    const { userRoles, isStudent, requestingUserIsOrgAdmin, isTeacher, isOrgUser } = useUserRole();
    
    const redirect = useCallback(() => {
        console.warn("useLoginRedirect:", userRoles);
        if (userRoles.length > 0) {
            if (isStudent) {
                window.location.href = "#/students/dashboard";
            } else if (requestingUserIsOrgAdmin || isOrgUser || isTeacher) {
                try { sessionStorage.setItem("lyw_start_tour_on_load", "1"); } catch (_) {}
                window.location.href = "#/app";
            } else {
                try { sessionStorage.setItem("lyw_start_tour_on_load", "1"); } catch (_) {}
                window.location.href = "#/app";
            }
        }
    }, [userRoles, isStudent, requestingUserIsOrgAdmin, isOrgUser, isTeacher]);

    return redirect;
}
